module.exports = __webpack_public_path__ + "img/lai_heen_galaxy.0261494f.jpg";